var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "body",
      {
        staticClass:
          "home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container",
        staticStyle: { "overflow-y": "unset" },
        attrs: { "data-anchor": "pagetop" }
      },
      [
        _c("navbar", {
          attrs: {
            follow: "st-Header",
            imgSrc: "../../../static/img/logo/logo-white.png"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "st-FixedPoint" }),
        _vm._v(" "),
        _c("div", { staticClass: "st-MainContainer" }, [
          _c("main", { staticClass: "st-MainContents" }, [
            _c("div", { staticClass: "top-Mv" }, [
              _c(
                "div",
                {
                  staticClass:
                    "top-Mv_Slide swiper-container swiper-container-fade swiper-container-initialized swiper-container-horizontal"
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "swiper-pagination swiper-pagination-clickable swiper-pagination-bullets"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "swiper-pagination-bullet swiper-pagination-bullet-active",
                          attrs: {
                            tabindex: "0",
                            role: "button",
                            "aria-label": "Go to slide 1"
                          },
                          on: {
                            click: function($event) {
                              return _vm.swiperPagination($event, 0)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "circle" }, [
                            _c("svg", { attrs: { viewBox: "0 0 124 124" } }, [
                              _c("circle", {
                                staticStyle: { "animation-duration": "5000ms" },
                                attrs: { cx: "62", cy: "62", r: "60" }
                              })
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "swiper-pagination-bullet",
                          attrs: {
                            tabindex: "0",
                            role: "button",
                            "aria-label": "Go to slide 2"
                          },
                          on: {
                            click: function($event) {
                              return _vm.swiperPagination($event, 1)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "circle" }, [
                            _c("svg", { attrs: { viewBox: "0 0 124 124" } }, [
                              _c("circle", {
                                staticStyle: { "animation-duration": "5000ms" },
                                attrs: { cx: "62", cy: "62", r: "60" }
                              })
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "swiper-pagination-bullet",
                          attrs: {
                            tabindex: "0",
                            role: "button",
                            "aria-label": "Go to slide 3"
                          },
                          on: {
                            click: function($event) {
                              return _vm.swiperPagination($event, 2)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "circle" }, [
                            _c("svg", { attrs: { viewBox: "0 0 124 124" } }, [
                              _c("circle", {
                                staticStyle: { "animation-duration": "5000ms" },
                                attrs: { cx: "62", cy: "62", r: "60" }
                              })
                            ])
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "swiper-notification",
                    attrs: { "aria-live": "assertive", "aria-atomic": "true" }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "section",
              {
                staticClass: "top-card st-Grid",
                staticStyle: { "background-color": "#fff" }
              },
              [
                _c("div", { staticClass: "container-row-warp p-0" }, [
                  _c(
                    "div",
                    { staticClass: "st-Grid_Inner st-Grid_Inner_appear p-0" },
                    [
                      _c(
                        "h2",
                        {
                          staticClass:
                            "sw-Section_Header home-compyany-appear-1",
                          attrs: { "data-appear": "true" }
                        },
                        [
                          _c("span", { staticClass: "sw-Section_Header-en" }, [
                            _c(
                              "b",
                              [
                                _c(
                                  "font",
                                  [_c("font", [_vm._v("COMPYANY")])],
                                  1
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "sw-Section_Header-ja" }, [
                            _c(
                              "b",
                              [
                                _c(
                                  "font",
                                  [_c("font", [_vm._v("企業情報")])],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "row col-12 p-md-0 m-0 common-appear home-compyany-appear-2",
                      attrs: { "data-appear": "true" }
                    },
                    [
                      _c("div", { staticClass: "col-md-4 text-center" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 46 46"
                            }
                          },
                          [
                            _c("defs", [
                              _c(
                                "clipPath",
                                { attrs: { id: "compyany-svg-image1" } },
                                [
                                  _c("path", {
                                    attrs: {
                                      fill: "none",
                                      transform: "rotate(0 23 23)",
                                      d:
                                        "M31 3.5a5 5 90 014 3l8 14a5 5 90 010 5l-8 14a5 5 90 01-4 3h-16a5 5 90 01-4-3l-8-14a5 5 90 010-5l8-14a5 5 90 014-3z"
                                    }
                                  })
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("image", {
                              attrs: {
                                "clip-path": "url(#compyany-svg-image1)",
                                height: "100%",
                                width: "100%",
                                href: "../../../static/img/home/home-12.jpg"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                fill: "none",
                                stroke: "white",
                                "stroke-width": "0",
                                transform: "rotate(0 23 23)",
                                opacity: ".5",
                                d:
                                  "M31 3.5a5 5 90 014 3l8 14a5 5 90 010 5l-8 14a5 5 90 01-4 3h-16a5 5 90 01-4-3l-8-14a5 5 90 010-5l8-14a5 5 90 014-3z"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-left" }, [
                          _vm._m(1),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "bt_more" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "bt_more_a",
                                  attrs: { to: "/company/profile" }
                                },
                                [_vm._v("会社概要")]
                              )
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4 text-center show-pc" },
                        [
                          _c("div", { staticClass: "text-left" }, [
                            _c("br"),
                            _vm._v(" "),
                            _vm._m(2),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "bt_more" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "bt_more_a",
                                    attrs: { to: "/service/index" }
                                  },
                                  [_vm._v("サービス案内")]
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 46 46"
                              }
                            },
                            [
                              _c("defs", [
                                _c(
                                  "clipPath",
                                  { attrs: { id: "compyany-svg-image2-1" } },
                                  [
                                    _c("path", {
                                      attrs: {
                                        fill: "none",
                                        transform: "rotate(0 23 23)",
                                        d:
                                          "M31 3.5a5 5 90 014 3l8 14a5 5 90 010 5l-8 14a5 5 90 01-4 3h-16a5 5 90 01-4-3l-8-14a5 5 90 010-5l8-14a5 5 90 014-3z"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("image", {
                                attrs: {
                                  "clip-path": "url(#compyany-svg-image2-1)",
                                  height: "100%",
                                  width: "100%",
                                  href: "../../../static/img/home/home-11.jpg"
                                }
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  fill: "none",
                                  stroke: "white",
                                  "stroke-width": "0",
                                  transform: "rotate(0 23 23)",
                                  opacity: ".5",
                                  d:
                                    "M31 3.5a5 5 90 014 3l8 14a5 5 90 010 5l-8 14a5 5 90 01-4 3h-16a5 5 90 01-4-3l-8-14a5 5 90 010-5l8-14a5 5 90 014-3z"
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4 text-center show-sp" },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 46 46"
                              }
                            },
                            [
                              _c("defs", [
                                _c(
                                  "clipPath",
                                  { attrs: { id: "compyany-svg-image2-2" } },
                                  [
                                    _c("path", {
                                      attrs: {
                                        fill: "none",
                                        transform: "rotate(0 23 23)",
                                        d:
                                          "M31 3.5a5 5 90 014 3l8 14a5 5 90 010 5l-8 14a5 5 90 01-4 3h-16a5 5 90 01-4-3l-8-14a5 5 90 010-5l8-14a5 5 90 014-3z"
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("image", {
                                attrs: {
                                  "clip-path": "url(#compyany-svg-image2-2)",
                                  height: "100%",
                                  width: "100%",
                                  href: "../../../static/img/home/home-11.jpg"
                                }
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  fill: "none",
                                  stroke: "white",
                                  "stroke-width": "0",
                                  transform: "rotate(0 23 23)",
                                  opacity: ".5",
                                  d:
                                    "M31 3.5a5 5 90 014 3l8 14a5 5 90 010 5l-8 14a5 5 90 01-4 3h-16a5 5 90 01-4-3l-8-14a5 5 90 010-5l8-14a5 5 90 014-3z"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-left" }, [
                            _c("br"),
                            _vm._v(" "),
                            _vm._m(3),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "bt_more" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "bt_more_a",
                                    attrs: { to: "/service/index" }
                                  },
                                  [_vm._v("サービス案内")]
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4 text-center" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 46 46"
                            }
                          },
                          [
                            _c("defs", [
                              _c(
                                "clipPath",
                                { attrs: { id: "compyany-svg-image3" } },
                                [
                                  _c("path", {
                                    attrs: {
                                      fill: "none",
                                      transform: "rotate(0 23 23)",
                                      d:
                                        "M31 3.5a5 5 90 014 3l8 14a5 5 90 010 5l-8 14a5 5 90 01-4 3h-16a5 5 90 01-4-3l-8-14a5 5 90 010-5l8-14a5 5 90 014-3z"
                                    }
                                  })
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("image", {
                              attrs: {
                                "clip-path": "url(#compyany-svg-image3)",
                                height: "100%",
                                width: "100%",
                                href: "../../../static/img/home/home-13.jpg"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                fill: "none",
                                stroke: "white",
                                "stroke-width": "0",
                                transform: "rotate(0 23 23)",
                                opacity: ".5",
                                d:
                                  "M31 3.5a5 5 90 014 3l8 14a5 5 90 010 5l-8 14a5 5 90 01-4 3h-16a5 5 90 01-4-3l-8-14a5 5 90 010-5l8-14a5 5 90 014-3z"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-left" }, [
                          _vm._m(4),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "bt_more" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "bt_more_a",
                                  attrs: {
                                    to: "/solution/logistics-automation"
                                  }
                                },
                                [_vm._v("ソリューションズ")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ]
                  )
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("copyright")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "swiper-wrapper" }, [
      _c(
        "div",
        {
          staticClass: "swiper-slide top-Mv_Slide-item",
          attrs: {
            "data-swiper-autoplay": "5000",
            "data-swiper-slide-index": "0"
          }
        },
        [
          _c("a", { attrs: { href: "javascript:void(0)" } }, [
            _c("div", { staticClass: "top-Mv_Slide-image" }, [
              _c("div", { staticClass: "top-Mv_Slide-image-sp" }, [
                _c("div", {
                  staticClass:
                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image1",
                  staticStyle: {
                    background:
                      "url(../../../static/img/home/home1.jpg) 50%/cover no-repeat"
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image2",
                  staticStyle: {
                    background:
                      "url(../../../static/img/home/home1.jpg) 50%/cover no-repeat"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "top-Mv_Slide-image-pc" }, [
                _c("div", {
                  staticClass:
                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image1",
                  staticStyle: {
                    background:
                      "url(../../../static/img/home/home1.jpg) 50%/cover no-repeat"
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image2",
                  staticStyle: {
                    background:
                      "url(../../../static/img/home/home1.jpg) 50%/cover no-repeat"
                  }
                })
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "swiper-slide top-Mv_Slide-item",
          attrs: {
            "data-swiper-autoplay": "5000",
            "data-swiper-slide-index": "1"
          }
        },
        [
          _c("a", { attrs: { href: "javascript:void(0)" } }, [
            _c("div", { staticClass: "top-Mv_Slide-image" }, [
              _c("div", { staticClass: "top-Mv_Slide-image-sp" }, [
                _c("div", {
                  staticClass:
                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image1",
                  staticStyle: {
                    background:
                      "url(../../../static/img/home/home2.jpg) 50%/cover no-repeat"
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image2",
                  staticStyle: {
                    background:
                      "url(../../../static/img/home/home2.jpg) 50%/cover no-repeat"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "top-Mv_Slide-image-pc" }, [
                _c("div", {
                  staticClass:
                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image1",
                  staticStyle: {
                    background:
                      "url(../../../static/img/home/home2.jpg) 50%/cover no-repeat"
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image2",
                  staticStyle: {
                    background:
                      "url(../../../static/img/home/home2.jpg) 50%/cover no-repeat"
                  }
                })
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "swiper-slide top-Mv_Slide-item",
          attrs: {
            "data-swiper-autoplay": "5000",
            "data-swiper-slide-index": "2"
          }
        },
        [
          _c("a", { attrs: { href: "javascript:void(0)" } }, [
            _c("div", { staticClass: "top-Mv_Slide-image" }, [
              _c("div", { staticClass: "top-Mv_Slide-image-sp" }, [
                _c("div", {
                  staticClass:
                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image1",
                  staticStyle: {
                    background:
                      "url(../../../static/img/home/home3.jpg) 50%/cover no-repeat"
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image2",
                  staticStyle: {
                    background:
                      "url(../../../static/img/home/home3.jpg) 50%/cover no-repeat"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "top-Mv_Slide-image-pc" }, [
                _c("div", {
                  staticClass:
                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image1",
                  staticStyle: {
                    background:
                      "url(../../../static/img/home/home3.jpg) 50%/cover no-repeat"
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image2",
                  staticStyle: {
                    background:
                      "url(../../../static/img/home/home3.jpg) 50%/cover no-repeat"
                  }
                })
              ])
            ])
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", [
      _c("img", {
        attrs: {
          src: require("../../../static/img/home/dx.png"),
          width: "60",
          height: "60"
        }
      }),
      _vm._v("会社概要")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", [
      _c("img", {
        attrs: {
          src: require("../../../static/img/home/ky.png"),
          width: "60",
          height: "60"
        }
      }),
      _vm._v("サービス案内")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", [
      _c("img", {
        attrs: {
          src: require("../../../static/img/home/ky.png"),
          width: "60",
          height: "60"
        }
      }),
      _vm._v("サービス案内")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", [
      _c("img", {
        attrs: {
          src: require("../../../static/img/home/sm.png"),
          width: "60",
          height: "60"
        }
      }),
      _vm._v("ソリューションズ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00b31332", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00b31332","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/home.vue
// module id = null
// module chunks = 